{
  "id": "campaign-060",
  "name": "Round Up the Sheep",
  "seed": "campaign:60:r1",
  "generatorVersion": 3,
  "level": 60,
  "biome": "farm",
  "startDir": "N",
  "mowerRule": {
    "kind": "exclude",
    "mowers": ["fairway"]
  },
  "rows": [
    "....PPPP....",
    "....PPPP....",
    ".....G......",
    "............",
    "............",
    "#.........u.",
    "............",
    "............",
    "..#.........",
    "..........y.",
    "............",
    "............",
    "............",
    "............",
    "............",
    "...........S"
  ],
  "pickups": [
    {
      "kind": "coin",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 0
    },
    {
      "kind": "gas",
      "x": 6,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 14
    }
  ],
  "critters": [
    {
      "kind": "sheep",
      "x": 5,
      "y": 8
    },
    {
      "kind": "sheep",
      "x": 8,
      "y": 8
    },
    {
      "kind": "sheep",
      "x": 9,
      "y": 12
    },
    {
      "kind": "sheep",
      "x": 3,
      "y": 12
    }
  ],
  "herd": true,
  "par": {
    "reel": 9000,
    "push": 6630,
    "selfPropelled": 5976,
    "tractor": 6840,
    "zeroTurn": 4029
  }
}
